<template>
  <v-slide-x-reverse-transition>
    <v-card
      class="elevation-5 condition-details vop-bg-whisper"
      v-show="isVisible"
    >
      <div>
        <!-- Header title -->
        <v-toolbar flat color="vop-bg-whisper">
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span v-if="isEditMode">{{ messages.label.EDIT_CONDITION }}</span>
            <span v-else>{{ messages.label.ADD_CONDITION }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hide()">
            <v-icon medium>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex>
              <v-form>
                <v-flex xs8>
                  <v-select
                    :disabled="isEditMode"
                    v-model="condition.conditionType"
                    @change="handleConditionTypeChange"
                    label="Condition Type"
                    v-validate="'required'"
                    :error-messages="errors.collect('conditionType')"
                    data-vv-name="conditionType"
                    :items="conditionTypes"
                    item-text="title"
                    item-value="value"
                    required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs8>
                  <v-text-field
                    v-model="condition.title"
                    v-validate="{
                      required: true,
                      max: 100,
                      regex: REGEX_TITLE
                    }"
                    :error-messages="errors.collect('title')"
                    data-vv-name="title"
                    data-vv-delay="500"
                    :counter="100"
                    label="Title"
                    required
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs8>
                  <v-autocomplete
                    v-model="condition.field"
                    label="Field"
                    v-validate="'required'"
                    :error-messages="errors.collect('conditionField')"
                    data-vv-name="conditionField"
                    :items="xpathMappingsList"
                    item-text="title"
                    item-value="xpathLocation"
                    :loading="xpathMappingsListLoading"
                    required
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex>
                  <!-- Compare -->
                  <template v-if="condition.conditionType === 'compare'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-select
                          v-model="selectedCompareValueType"
                          label="Value Type"
                          v-validate="'required'"
                          :error-messages="errors.collect('valueType')"
                          data-vv-name="valueType"
                          :items="compareValueTypes"
                          required
                        >
                        </v-select>
                      </v-flex>
                      <!-- value type : date / datetime -->
                      <template
                        v-if="selectedCompareValueType === 'date/datetime'"
                      >
                        <!-- Format Input -->
                        <v-flex xs6 offset-xs1>
                          <v-text-field
                            v-model="dateOrDateTimeFormat"
                            label="Add date or datetime Format"
                            append-outer-icon="add_circle"
                            @keyup.enter="addDateOrDateTimeFormat"
                            v-validate="{
                              required: false,
                              max: 50,
                              regex: REGEX_DATE_FORMAT
                            }"
                            :error-messages="errors.collect('dateFormat')"
                            data-vv-name="dateFormat"
                            :counter="100"
                            @click:append-outer="addDateOrDateTimeFormat"
                          >
                          </v-text-field>
                        </v-flex>
                        <!-- Formats list -->
                        <v-flex xs12 offset-xs1>
                          <span class="subheading">Format(s)</span>
                          <v-layout row wrap>
                            <v-flex
                              xs4
                              v-for="format in dateAndDateTimeFormats"
                              :key="format.value"
                            >
                              <v-checkbox
                                v-model="selectedDateAndDateTimeFormats"
                                :label="format.value"
                                :value="format.value"
                              >
                              </v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <!-- Operator -->
                        <v-flex xs6 offset-xs1>
                          <v-select
                            v-model="condition.operator"
                            label="Operator"
                            v-validate="'required'"
                            :error-messages="errors.collect('operator')"
                            data-vv-name="operator"
                            :items="compareOperators"
                            item-text="label"
                            item-value="value"
                            required
                          >
                          </v-select>
                        </v-flex>
                        <!-- Compare Value -->
                        <v-flex xs6 offset-xs1>
                          <span class="subheading">Value</span>
                          <v-radio-group
                            v-model="dateAndDateTimeCompareValueType"
                            row
                          >
                            <v-radio label="NOW" value="NOW"></v-radio>
                            <v-radio label="Field" value="Field"></v-radio>
                            <v-radio label="Date" value="Date"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <!-- Compare value 'Field' -->
                        <v-flex
                          xs6
                          v-if="dateAndDateTimeCompareValueType === 'Field'"
                          offset-xs1
                        >
                          <v-select
                            v-model="selectedCompareField"
                            label="Field"
                            v-validate="'required'"
                            :error-messages="errors.collect('compareField')"
                            data-vv-name="compareField"
                            :items="xpathMappingsList"
                            item-text="title"
                            item-value="xpathLocation"
                            required
                          >
                          </v-select>
                        </v-flex>
                        <!-- Compare value 'Date' -->
                        <v-flex
                          xs6
                          v-if="dateAndDateTimeCompareValueType === 'Date'"
                          offset-xs1
                        >
                          <v-menu
                            v-model="compareDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="selectedCompareDate"
                                label="Value"
                                prepend-icon="event"
                                v-validate="'required'"
                                :error-messages="errors.collect('compareDate')"
                                data-vv-name="compareDate"
                                readonly
                                v-on="on"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="selectedCompareDate"
                              @input="compareDateMenu = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </template>
                      <!-- value type : numeric -->
                      <template v-if="selectedCompareValueType === 'numeric'">
                        <!-- Operator -->
                        <v-flex xs6 offset-xs1>
                          <v-select
                            v-model="condition.operator"
                            label="Operator"
                            v-validate="'required'"
                            :error-messages="errors.collect('operator')"
                            data-vv-name="operator"
                            :items="compareOperators"
                            item-text="label"
                            item-value="value"
                            required
                          >
                          </v-select>
                        </v-flex>
                        <!-- Compare value 'Field' -->
                        <v-flex xs6 offset-xs1>
                          <v-select
                            v-model="selectedCompareField"
                            label="Field"
                            v-validate="'required'"
                            :error-messages="errors.collect('compareField')"
                            data-vv-name="compareField"
                            :items="xpathMappingsList"
                            item-text="title"
                            item-value="xpathLocation"
                            required
                          >
                          </v-select>
                        </v-flex>
                      </template>
                    </v-layout>
                  </template>
                  <!-- Is Enumerated Value -->
                  <template
                    v-if="condition.conditionType === 'isEnumeratedValue'"
                  >
                    <v-layout class="indigo lighten-5" column>
                      <v-flex xs12 offset-xs1>
                        <v-layout
                          row
                          wrap
                          class="px-2"
                          data-vv-scope="enumValues"
                        >
                          <v-flex
                            xs3
                            v-for="(enumObj, index) in enumValues"
                            :key="enumObj.id"
                          >
                            <!-- TODO : Add Validation for every etnry, not working as expected -->
                            <v-text-field
                              v-bind:value="enumObj.value"
                              @input="updateEnumValues(index, $event)"
                              @click:append-outer="removeEnumValue(index)"
                              clearable
                              append-outer-icon="remove_circle"
                              v-validate="{
                                required: true,
                                max: 20,
                                regex: REGEX_ENUM
                              }"
                              :error-messages="errors.collect('enumValue')"
                              data-vv-name="enumValue"
                              label="Enum Value"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs3 class="pa-2">
                            <v-btn
                              color="secondary"
                              class="mt-2"
                              @click="addEnumPlaceholder"
                              round
                              flat
                            >
                              <v-icon left>add_circle</v-icon><span>Add</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Exists -->
                  <template v-if="condition.conditionType === 'exists'">
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <!-- Exists Required -->
                  <template v-if="condition.conditionType === 'existsRequired'">
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <!-- Is Integer -->
                  <template v-if="condition.conditionType === 'isInteger'">
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <!-- Is Long -->
                  <template v-if="condition.conditionType === 'isLong'">
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <!-- Matches -->
                  <template v-if="condition.conditionType === 'matches'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field
                          v-model="condition.value"
                          v-validate="{
                            required: true,
                            max: 1000,
                            isRegEx: true
                          }"
                          :error-messages="errors.collect('matchesValue')"
                          data-vv-name="matchesValue"
                          label="Match"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Max Length -->
                  <template v-if="condition.conditionType === 'maxLength'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs3 offset-xs1>
                        <v-text-field
                          v-model="condition.value"
                          v-validate="'required|max:100|numeric'"
                          :error-messages="errors.collect('maxLengthValue')"
                          data-vv-name="maxLengthValue"
                          label="Length"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Is In Range -->
                  <template v-if="condition.conditionType === 'isInRange'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs3 offset-xs1>
                        <v-text-field
                          v-model="rangeStart"
                          v-validate="'required|max:10|alpha_num'"
                          :error-messages="errors.collect('isInRangeStart')"
                          data-vv-name="isInRangeStart"
                          label="Start"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs3 offset-xs1>
                        <v-text-field
                          v-model="rangeEnd"
                          v-validate="'required|max:10|alpha_num'"
                          :error-messages="errors.collect('isInRangeEnd')"
                          data-vv-name="isInRangeEnd"
                          label="End"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Is Valid Format -->
                  <template v-if="condition.conditionType === 'isValidFormat'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <!-- Format Input -->
                      <v-flex xs6 offset-xs1>
                        <v-text-field
                          v-model="dateOrDateTimeFormat"
                          label="Add date or datetime Format"
                          append-outer-icon="add_circle"
                          @keyup.enter="addDateOrDateTimeFormat"
                          v-validate="{
                            required: false,
                            max: 50,
                            regex: REGEX_DATE_FORMAT
                          }"
                          :error-messages="errors.collect('dateFormat')"
                          data-vv-name="dateFormat"
                          :counter="100"
                          @click:append-outer="addDateOrDateTimeFormat"
                        >
                        </v-text-field>
                      </v-flex>
                      <!-- Formats list -->
                      <v-flex xs12 offset-xs1>
                        <span class="subheading">Format(s)</span>
                        <v-layout row wrap>
                          <v-flex
                            xs4
                            v-for="format in dateAndDateTimeFormats"
                            :key="format.value"
                          >
                            <v-checkbox
                              v-model="selectedDateAndDateTimeFormats"
                              :label="format.value"
                              :value="format.value"
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Are List Items Identical -->
                  <template
                    v-if="condition.conditionType === 'areListItemsUnique'"
                  >
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <!-- Are List Items Unique -->
                  <template
                    v-if="condition.conditionType === 'areListItemsIdentical'"
                  >
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <!-- Is Supported Language -->
                  <template
                    v-if="condition.conditionType === 'isSupportedLanguage'"
                  >
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <template
                    v-if="condition.conditionType === 'isSupportedCharacters'"
                  >
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                  <template
                    v-if="condition.conditionType === 'isSupportedCountry'"
                  >
                    <div>
                      <!-- Probably Nothing -->
                    </div>
                  </template>
                </v-flex>
                <v-flex xs4>
                  <v-select
                    v-model="condition.severity"
                    label="Severity"
                    v-validate="'required'"
                    :error-messages="errors.collect('severity')"
                    data-vv-name="severity"
                    :items="severityLevels"
                    required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs4>
                  <span class="subheading">Negate</span>
                  <v-switch
                    v-model="conditionNegate"
                    color="primary"
                    class="mt-0"
                  ></v-switch>
                </v-flex>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <v-spacer />
        <!-- Delete Condition -->
        <v-dialog v-model="deleteDialog" width="500" v-if="isEditMode">
          <v-btn color="error" slot="activator">
            {{ messages.label.REMOVE }}
          </v-btn>
          <v-card>
            <v-card-title class="subheading ttu">
              {{ messages.label.DELETE_CONDITION }}
            </v-card-title>
            <v-card-text>
              <p>
                {{ messages.info.DELETE_CONDITION_MSG }}
                <b>{{ condition.title }}</b> ?
              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey lighten-1 white--text"
                @click="deleteDialog = false"
              >
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" @click="deleteCondition">
                {{ messages.label.DELETE }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          color="primary"
          class="ml-2"
          :disabled="updatingCondition"
          :loading="updatingCondition"
          v-if="isEditMode"
          @click="updateCondition"
        >
          {{ messages.label.DONE }}
        </v-btn>
        <v-btn
          color="primary"
          class="ml-2"
          :disabled="addingCondition"
          :loading="addingCondition"
          @click="addCondition"
          v-else
        >
          {{ messages.label.ADD }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import uniqid from "uniqid";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import messages from "@/XVAT/messages.json";
import XVATRulesService from "@/XVAT/XVATRulesService";
import { GET_XPATH_MAPPINGS_LIST } from "@/store/constants/action-types";
import { REGEX_TITLE, REGEX_ENUM, REGEX_DATE_FORMAT } from "@/Shared/constants";

export default {
  name: "ConditionDetails",
  $_veeValidate: {
    validator: "new"
  },
  computed: {
    ...mapState("xvat", ["xpathMappingsList", "xpathMappingsListLoading"])
  },
  data() {
    return {
      condition: {
        id: "",
        title: "",
        field: "",
        format: "",
        operator: "",
        conditionType: "",
        severity: "ERROR",
        value: ""
      },
      loadingXpathMappings: false,
      conditionTypes: this.retrieveConditionTypes(),
      // Compare
      compareValueTypes: ["date/datetime", "numeric"],
      selectedCompareValueType: "",
      dateOrDateTimeFormat: "",
      dateAndDateTimeFormats: this.getDateAndDateTimeFormats(),
      selectedDateAndDateTimeFormats: this.getDefaultDateTimeFormats(),
      compareOperators: this.getCompareOperators(),
      dateAndDateTimeCompareValueType: "NOW", // Defaults to 'NOW'
      selectedCompareField: "",
      selectedCompareDate: new Date().toISOString().substr(0, 10),
      compareDateMenu: false,
      // Enum
      enumValues: [],
      // Range
      rangeStart: "",
      rangeEnd: "",
      // Format
      formatValues: [],
      // Severity
      severityLevels: ["ERROR", "WARN"],
      conditionNegate: false,
      isEditMode: false,
      isVisible: false,
      valid: false,
      deleteDialog: false,
      dictionary: this.getValidationDictionary(),
      addingCondition: false,
      updatingCondition: false,
      REGEX_TITLE: REGEX_TITLE,
      REGEX_ENUM: REGEX_ENUM,
      REGEX_DATE_FORMAT: REGEX_DATE_FORMAT
    };
  },
  watch: {
    condition: {
      handler(newValue, oldValue) {
        // Populate data when the condition selection changes
        if (newValue.id !== oldValue.id && !this.$lodash.isEmpty(newValue.id)) {
          this.populateConditionData(newValue);
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("xvat", [GET_XPATH_MAPPINGS_LIST]),

    /**
     * hide - Hide side sheet view
     */
    hide() {
      this.isVisible = false;
      this.resetConditionDetails();
      XVATRulesService.$emit("event:hideConditionDetailsSheet");
    },

    /**
     * show - Show side sheet view
     */
    show(condition) {
      this.resetConditionData();
      // Wait before updating form
      this.$nextTick(() => {
        this.isVisible = true;
        this.$validator.reset();
        if (
          !this.$lodash.isUndefined(condition) &&
          !this.$lodash.isEmpty(condition)
        ) {
          this.isEditMode = true;
          this.condition = this.$lodash.cloneDeep(condition);
        } else {
          this.isEditMode = false;
        }
      });
    },

    /**
     * resetConditionData - re initializes data for this view
     */
    resetConditionData() {
      this.condition = {
        id: "",
        title: "",
        field: "",
        format: "",
        operator: "",
        conditionType: "",
        severity: "ERROR",
        value: ""
      };
      this.selectedCompareValueType = "";
      this.dateOrDateTimeFormat = "";
      this.dateAndDateTimeFormats = this.getDateAndDateTimeFormats();
      this.selectedDateAndDateTimeFormats = this.getDefaultDateTimeFormats();
      this.dateAndDateTimeCompareValueType = "NOW";
      this.selectedCompareField = "";
      this.selectedCompareDate = new Date().toISOString().substr(0, 10);
      this.enumValues = [];
      this.formatValues = [];
      this.rangeStart = "";
      this.rangeEnd = "";
      this.conditionNegate = false;
    },

    /**
     * retrieveConditionTypes - List of condition types supported
     * @returns {array}
     */
    retrieveConditionTypes() {
      let conditionTypes = [
        {
          id: 1,
          title: "Compare",
          value: "compare"
        },
        {
          id: 2,
          title: "Is Enumerated Value",
          value: "isEnumeratedValue"
        },
        {
          id: 3,
          title: "Exists",
          value: "exists"
        },
        {
          id: 4,
          title: "Exists Required",
          value: "existsRequired"
        },
        {
          id: 5,
          title: "Is Integer",
          value: "isInteger"
        },
        {
          id: 6,
          title: "Is Long",
          value: "isLong"
        },
        {
          id: 7,
          title: "Matches",
          value: "matches"
        },
        {
          id: 8,
          title: "Max Length",
          value: "maxLength"
        },
        {
          id: 9,
          title: "Is In Range",
          value: "isInRange"
        },
        {
          id: 10,
          title: "Is Valid Format",
          value: "isValidFormat"
        },
        {
          id: 11,
          title: "Are List Items Identical",
          value: "areListItemsIdentical"
        },
        {
          id: 12,
          title: "Are List Items Unique",
          value: "areListItemsUnique"
        },
        {
          id: 13,
          title: "Is Supported Language",
          value: "isSupportedLanguage"
        },
        {
          id: 14,
          title: "Is Supported Characters",
          value: "isSupportedCharacters"
        },
        {
          id: 15,
          title: "Is Supported Country",
          value: "isSupportedCountry"
        }
      ];

      conditionTypes = this.$lodash.sortBy(conditionTypes, ["title"]);
      return conditionTypes;
    },

    /**
     * getDateAndDateTimeFormats - Retrieve supported date / datetime formats
     * @returns {array}
     */
    getDateAndDateTimeFormats() {
      return [
        {
          default: true,
          value: "yyyy-MM-dd"
        },
        {
          default: true,
          value: "HH:mm"
        },
        {
          default: true,
          value: "yyyy-MM-dd'T'HH:mm:ss"
        },
        {
          default: true,
          value: "yyyy-MM-dd'T'HH:mm"
        },
        {
          default: true,
          value: "HH:mm:ss"
        },
        {
          default: true,
          value: "yyyy"
        }
      ];
    },

    /**
     * getDefaultDateTimeFormats - consturct default selection array
     * @returns {array}
     */
    getDefaultDateTimeFormats() {
      let formats = this.getDateAndDateTimeFormats();
      let defaultSelected = this.$lodash.filter(formats, ["default", true]);
      let defaultSelectedArray = this.$lodash.map(defaultSelected, "value");

      return defaultSelectedArray;
    },

    /**
     * getCompareOperators
     * @returns {array}
     */
    getCompareOperators() {
      return [
        {
          value: "lt",
          label: "Less Than"
        },
        {
          value: "le",
          label: "Less Than or Equal"
        },
        {
          value: "eq",
          label: "Equal"
        },
        {
          value: "ge",
          label: "Greater Than or Equal"
        },
        {
          value: "gt",
          label: "Greater Than"
        }
      ];
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters",
            regex: "Please use valid characters: A-Z a-z 0-9 / _ - and space"
          },
          conditionField: {
            required: () => "Field can't be empty"
          },
          compareField: {
            required: () => "Field can't be empty"
          },
          conditionType: {
            required: () => "Condition Type can't be empty"
          },
          valueType: {
            required: () => "Value Type value can't be empty"
          },
          dateFormat: {
            max: () => "Format value can't be greater than 50 chracters",
            regex: () => "Please use valid characters: A-Z a-z 0-9 / : . -"
          },
          compareDate: {
            required: () => "Date can't be empty"
          },
          enumValue: {
            required: () => "Enum value can't be empty",
            max: () => "Enum value can't be greater than 20 chracters",
            regex: "Please use valid characters: A-Z a-z 0-9 _ - . @ /"
          },
          compareValue: {
            required: () => "Compare value can't be empty"
          },
          matchesValue: {
            required: () => "Match value can't be empty",
            max: () => "Regular Expressions can't be longer than 1000 chracters"
          },
          maxLengthValue: {
            required: () => "Max Length value can't be empty",
            max: () => "Max Length can't be greater than 100 chracters",
            numeric: "Max Length may only contain numeric characters"
          },
          isInRangeStart: {
            required: () => "Range Start value can't be empty",
            alpha_num: "Please use valid characters: A-Z a-z 0-9"
          },
          isInRangeEnd: {
            required: () => "Range End value can't be empty",
            alpha_num: "Please use valid characters: A-Z a-z 0-9"
          },
          formatValue: {
            required: () => "Format value can't be empty"
          },
          severity: {
            required: () => "Please select severity"
          },
          operator: {
            required: () => "Please select operator"
          }
        }
      };
    },

    /**
     * addDateorDateTimeFormat - Add new format
     */
    addDateOrDateTimeFormat() {
      if (this.dateOrDateTimeFormat === "") {
        return false;
      }

      this.$validator.validate("dateFormat").then(result => {
        if (result) {
          let existingFormat = this.$lodash.find(this.dateAndDateTimeFormats, {
            value: this.dateOrDateTimeFormat
          });
          // Add only if the format doesn't exist already
          if (this.$lodash.isUndefined(existingFormat)) {
            this.dateAndDateTimeFormats.push({
              default: false,
              value: this.dateOrDateTimeFormat
            });
            this.selectedDateAndDateTimeFormats.push(this.dateOrDateTimeFormat); // update selection
            this.dateOrDateTimeFormat = "";
          }
        }
      });
    },

    /**
     * addCondition - Add new acondition
     */
    addCondition() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let conditionObj = this.constructConditionObject();
          XVATRulesService.$emit("event:addCondition", conditionObj);
          this.hide();
        }
      });
    },

    /**
     * updateCondition - update condition details
     */
    updateCondition() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let conditionObj = this.constructConditionObject();
          XVATRulesService.$emit("event:updateCondition", conditionObj);
          XVATRulesService.$emit("event:displaySaveRuleMsg");
          this.hide();
        }
      });
    },

    /**
     * deleteCondition - Delete condition
     */
    deleteCondition() {
      XVATRulesService.$emit("event:deleteCondition", this.condition);
      this.deleteDialog = false;
      XVATRulesService.$emit("event:displaySaveRuleMsg");
      this.hide();
    },

    /**
     * constructConditionObject - Construct condition object
     */
    constructConditionObject() {
      const conditionType = this.condition.conditionType;
      let conditionObject = {
        title: this.condition.title,
        field: this.condition.field,
        conditionType: this.condition.conditionType,
        severity: this.condition.severity,
        negate: this.conditionNegate
      };

      // Add id if it does't exist
      if (
        this.$lodash.isUndefined(this.condition.id) ||
        this.$lodash.isEmpty(this.condition.id)
      ) {
        conditionObject.id = uniqid();
      } else {
        // Use existing id
        conditionObject.id = this.condition.id;
      }

      switch (conditionType) {
        case "compare":
          // Capture operator
          conditionObject.operator = this.condition.operator;
          // Construct format, value and
          switch (this.selectedCompareValueType) {
            case "date/datetime":
              let formatsList = this.selectedDateAndDateTimeFormats.join("|");
              conditionObject.format = "date=(" + formatsList + ")";
              // retrieve value for date/datetime
              switch (this.dateAndDateTimeCompareValueType) {
                case "NOW":
                  conditionObject.value = "NOW"; // Special case
                  break;
                case "Field":
                  conditionObject.value = this.selectedCompareField;
                  break;
                case "Date":
                  conditionObject.value = this.selectedCompareDate;
                  break;
              }
              break; // end - date/datetime case
            case "numeric":
              conditionObject.format = "number=(#)";
              conditionObject.value = this.selectedCompareField;
              break; // end - numeric case
          }
          break; // end - compare case
        case "isEnumeratedValue":
          conditionObject.value = this.$lodash
            .map(this.enumValues, "value")
            .join(",");
          break;
        case "exists":
          conditionObject.value = "";
          break;
        case "existsRequired":
          conditionObject.value = "";
          break;
        case "isLong":
          conditionObject.value = "";
          break;
        case "matches":
          conditionObject.value = this.condition.value;
          break;
        case "maxLength":
          conditionObject.value = this.condition.value;
          break;
        case "isInRange":
          conditionObject.value = this.rangeStart + "-" + this.rangeEnd;
          break;
        case "isValidFormat":
          let formatsList = this.selectedDateAndDateTimeFormats.join("|");
          // For now, we know it's going to be date format only
          conditionObject.format = "date=(" + formatsList + ")";
          break;
        case "areListItemsUnique":
          conditionObject.value = "";
          break;
        case "areListItemsIdentical":
          conditionObject.value = "";
          break;
        case "isSupportedLanguage":
          conditionObject.value = "";
          break;
      }
      // Remove 'value' if it's not defined or empty
      if (
        this.$lodash.isUndefined(conditionObject.value) ||
        this.$lodash.isEmpty(conditionObject.value)
      ) {
        conditionObject = this.$lodash.omit(conditionObject, "value");
      }
      console.log("Condition Object", conditionObject);
      return conditionObject;
    },

    /**
     * populateConditionData - Update view with conditon data
     * @param {object} conditionObj
     */
    populateConditionData(conditionObj) {
      if (conditionObj.conditionType === "isEnumeratedValue") {
        this.populateEnumValues();
      }
      if (conditionObj.conditionType === "isInRange") {
        this.populateRangeValues();
      }
      if (conditionObj.conditionType === "isValidFormat") {
        this.populateFormatValues();
      }
      if (conditionObj.conditionType === "compare") {
        this.populateCompareValues();
      }
      if (!this.$lodash.isUndefined(conditionObj.negate)) {
        this.conditionNegate = conditionObj.negate;
      }
    },

    /**
     * handleConditionTypeChange -
     */
    handleConditionTypeChange() {
      if (this.condition.conditionType === "isEnumeratedValue") {
        this.populateEnumValues();
      }
      // if (this.condition.conditionType === "matches") {
      //   this.$validator.reset()
      //   this.$validator.detach('dateFormat')
      // }
    },

    /**
     * populateEnumValues - Get enumerated values
     */
    populateEnumValues() {
      if (
        !this.$lodash.isUndefined(this.condition.value) &&
        !this.$lodash.isEmpty(this.condition.value)
      ) {
        let enumValuesArray = this.condition.value.split(",");
        this.$lodash.forEach(enumValuesArray, value => {
          let enumObject = {
            id: uniqid(),
            value: value
          };
          this.enumValues.push(enumObject);
        });
      }
      if (this.enumValues.length === 0) {
        this.addEnumPlaceholder();
      }
    },

    /**
     * updateEnumValues - Update enum values
     */
    updateEnumValues(index, inputValue) {
      this.$validator.validateAll("enumValues").then(value => {
        if (value) {
          this.enumValues[index].value = inputValue;
        }
      });
    },

    /**
     * removeEnumValue - Remove enumerated value
     * @param {number} index
     */
    removeEnumValue(index) {
      this.enumValues.splice(index, 1);
      if (this.enumValues.length === 0) {
        this.addEnumPlaceholder();
      }
    },

    /**
     * addEnumPlaceholder - Add placeholder for enumerated string
     */
    addEnumPlaceholder() {
      this.$validator.validateAll("enumValues").then(value => {
        if (value) {
          let enumObject = {
            id: uniqid(),
            value: ""
          };
          this.enumValues.push(enumObject);
        }
      });
    },

    /**
     * populateRangeValues - Get enumerated values
     */
    populateRangeValues() {
      if (
        !this.$lodash.isUndefined(this.condition.value) &&
        !this.$lodash.isEmpty(this.condition.value)
      ) {
        this.rangeStart = this.condition.value.split("-")[0];
        this.rangeEnd = this.condition.value.split("-")[1];
      }
    },

    /**
     * populateFormatValues - Populate format values
     */
    populateFormatValues() {
      if (
        !this.$lodash.isUndefined(this.condition.format) &&
        !this.$lodash.isEmpty(this.condition.format)
      ) {
        this.selectedDateAndDateTimeFormats = this.fetchFormatsArray(
          this.condition.format
        );
        this.dateAndDateTimeFormats = this.getDateAndDateTimeFormats();
        this.updateDefaultFormatsList();
      } else {
        this.dateAndDateTimeFormats = this.getDateAndDateTimeFormats();
        this.selectedDateAndDateTimeFormats = this.getDefaultDateTimeFormats();
      }
    },

    /**
     * populateCompareValues - Populate fields with compare values
     */
    populateCompareValues() {
      // Format
      if (this.condition.format.indexOf("date") > -1) {
        this.selectedCompareValueType = "date/datetime";
        this.selectedDateAndDateTimeFormats = this.fetchFormatsArray(
          this.condition.format
        );
        this.dateAndDateTimeFormats = this.getDateAndDateTimeFormats();
        this.updateDefaultFormatsList();
      } else if (this.condition.format.indexOf("number") > -1) {
        this.selectedCompareValueType = "numeric";
      }

      // Value
      if (!this.$lodash.isEmpty(this.condition.value)) {
        if (this.condition.value === "NOW") {
          this.dateAndDateTimeCompareValueType = "NOW";
        } else {
          let date = moment(this.condition.value);
          if (date.isValid()) {
            this.dateAndDateTimeCompareValueType = "Date";
            this.selectedCompareDate = this.condition.value;
          } else {
            this.dateAndDateTimeCompareValueType = "Field";
            this.selectedCompareField = this.condition.value;
          }
        }
      }
    },

    /**
     * updateDefaultFormatsList - Updates default date formats list if there are any new formats available
     */
    updateDefaultFormatsList() {
      if (this.selectedDateAndDateTimeFormats.length > 0) {
        this.$lodash.forEach(this.selectedDateAndDateTimeFormats, value => {
          if (
            !this.$lodash.find(this.dateAndDateTimeFormats, { value: value })
          ) {
            this.dateAndDateTimeFormats.push({
              default: false,
              value: value
            });
          }
        });
      }
    },

    /**
     * fetchFormatsArray - Retreive formats array from the format string
     * @returns {array}
     */
    fetchFormatsArray(formatString) {
      let braceStart = formatString.indexOf("(");
      let braceEnd = formatString.indexOf(")");
      let formats = formatString.substring(braceStart + 1, braceEnd).split("|");

      return formats;
    },

    /**
     * updateFormatValues - Update format values
     */
    updateFormatValues(index, value) {
      this.formatValues[index] = value;
    },

    /**
     * retrieveXPathMappings - Retreive mappings to display field dropdown
     */
    retrieveXPathMappings() {
      // Update store with xpath mappings
      if (this.xpathMappingsList.length === 0) {
        this.loadingXpathMappings = true;
        this.GET_XPATH_MAPPINGS_LIST()
          .catch(() => {
            // TODO: handle error
          })
          .finally(() => {
            this.loadingXpathMappings = false;
          });
      } else {
        return Promise.resolve(this.xpathMappingsList);
      }
    },

    /**
     * resetConditionDetails - Reset condition data and form
     */
    resetConditionDetails() {
      this.resetConditionData();
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    /**
     * Initialize custom validation rules
     * */
    initCustomValidationRules() {
      this.$validator.extend("isRegEx", {
        getMessage(field, args) {
          return "Value is not a valid Regular Expression";
        },
        validate(value, args) {
          var isValid = true;
          try {
            new RegExp(value);
          } catch (e) {
            isValid = false;
          }
          return isValid;
        }
      });
    }
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.initCustomValidationRules();
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages;
    /**
     * Initial data
     */
    this.retrieveXPathMappings();
    /**
     * Events
     */
    XVATRulesService.$on("event:showConditionDetailsSheet", this.show);
    XVATRulesService.$on("event:ruleDataRetrieved", this.hide);
  },
  beforeDestroy() {
    XVATRulesService.$off("event:showConditionDetailsSheet", this.show);
    XVATRulesService.$off("event:ruleDataRetrieved", this.hide);
  }
};
</script>

<style lang="scss">
.condition-details {
  min-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/Rule/ConditionDetails.vue